var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVineSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 6.883a4.4 4.4 0 0 1-1 .119c-1.728 0-3.057-1.22-3.057-3.342 0-1.04.397-1.58.959-1.58.535 0 .891.485.891 1.47 0 .56-.148 1.173-.257 1.536 0 0 .532.939 1.987.65.309-.693.477-1.592.477-2.38C12 1.233 10.93 0 8.97 0 6.957 0 5.778 1.567 5.778 3.633c0 2.046.946 3.803 2.505 4.604-.655 1.327-1.49 2.496-2.36 3.376-1.58-1.93-3.007-4.506-3.592-9.533H0c1.076 8.372 4.284 11.038 5.132 11.55.48.29.893.277 1.331.027.689-.396 2.756-2.487 3.902-4.937A7.6 7.6 0 0 0 12 8.532z"
})));
export default SvgChannelVineSm;